import _objectSpread from'@babel/runtime/helpers/objectSpread2';import _extends from'@babel/runtime/helpers/extends';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import React from'react';import Link from'../Link/Link.js';import usePathBuilder from'../../hooks/usePathBuilder.js';function CIAMLink(props) {
  var to = props.to,
    analyticsData = props.analyticsData,
    rest = _objectWithoutProperties(props, ["to", "analyticsData"]);
  var pathBuilder = usePathBuilder();
  var path = pathBuilder(to);
  return /*#__PURE__*/React.createElement(Link, _extends({}, rest, {
    to: path,
    analyticsData: analyticsData
  }));
}
process.env.NODE_ENV !== "production" ? CIAMLink.propTypes = _objectSpread({}, Link === null || Link === void 0 ? void 0 : Link.propTypes) : void 0;export{CIAMLink as default};